export const SUBSCRIBED = 'SUBSCRIBED'
export const WAITING_FOR_CONFIRMATION = 'WAITING_FOR_CONFIRMATION'
export const NOT_SUBSCRIBED = 'NOT_SUBSCRIBED'